/**
 * Shared logo loader for canvas-based share exports.
 *
 * Kept as a promise cache so paintCard/ShareCardModal don't refetch
 * the PNG every render — the same HTMLImageElement is reused across
 * every victory share, battle-card share, and any future export.
 *
 * Callers use it inside a try/catch so a failed decode never blocks
 * the share flow (they just render without the mark).
 */
let _logoPromise = null;

export function loadBrandLogo() {
  if (_logoPromise) return _logoPromise;
  _logoPromise = new Promise((resolve, reject) => {
    const img = new Image();
    // The PNG lives in /public, same origin as the app — no CORS setup
    // needed. But we set the attr anyway so future CDN moves are safe.
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = (e) => { _logoPromise = null; reject(e); };
    img.src = '/wildquest-logo.png';
  });
  return _logoPromise;
}

/** Draw the mark at (x, y) fitted to `size`px square, then reset ctx. */
export function drawBrandLogo(ctx, img, x, y, size, opacity = 1) {
  if (!img) return;
  ctx.save();
  ctx.globalAlpha = opacity;
  ctx.drawImage(img, x, y, size, size);
  ctx.restore();
}
